export default {
  name: 'project_products',
  component_path: 'modules/procedures/blocks/order/BlockProducts'
}